import { useState } from 'react';
import { Button } from '@/ui/Button';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import { RoundBadge } from '@/components/RoundBadge';
import { SideDrawer } from '@/components/SideDrawer';

export function FiltersButton({ activeCount, onClearAll, resultsCount, resultsLabel, sx, children, open: controlledOpen, onOpenChange }) {
  const [internalOpen, setInternalOpen] = useState(false);
  const open = controlledOpen ?? internalOpen;
  const setOpen = onOpenChange ?? setInternalOpen;

  return (
    <>
      <RoundBadge badgeContent={activeCount} sx={sx}>
        <Button          
          color={activeCount > 0 ? 'primary' : 'white'}                    
          size="xs"
          startDecorator={<TuneRoundedIcon />}
          onClick={() => setOpen(true)}
          sx={{ sx }}
        >
          Filters
        </Button>
      </RoundBadge>
      <SideDrawer
        open={open}
        onClose={() => setOpen(false)}
        title="Filters"
        backgroundColor="gray"
        footer={
          <>
            <Button color="neutral" disabled={activeCount === 0} onClick={onClearAll}>Clear all</Button>
            <Button type="wider" onClick={() => setOpen(false)}>Show {resultsCount} {resultsLabel}</Button>
          </>
        }
      >
        {children}
      </SideDrawer>
    </>
  );
}
